import { authProvider } from "../../services/Security";
import { convertModelDatesToUTCFromOperator } from './Functions';

export function getAutoPaymentBatch(id, date) {
    let getToken = new Promise<any>((resolve, reject) => {
        authProvider.getNexusToken()
            .then(x => {
                fetch(`/api/v2/autopay/batch/${id}/export`, {
                        method: 'GET',
                        headers: {
                            Authorization: 'Bearer ' + x,
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(r => r.blob())
                    .then((response) => {
                        download(response, `Auto_Payment_Batch_${date}`)
                        resolve(null)
                    })
                    .catch(err => reject(err))
            })

        })
    return getToken;
}

export function getAutoPayments(id, date) {
    let getToken = new Promise<any>((resolve, reject) => {
        authProvider.getNexusToken()
            .then(x => {
                fetch(`/api/v2/autopay/${id}/export`, {
                        method: 'GET',
                        headers: {
                            Authorization: 'Bearer ' + x,
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(r => r.blob())
                    .then((response) => {
                        download(response, `Auto_Payments_${date}`)
                        resolve(null)
                    })
                    .catch(err => reject(err))
            })

        })
    return getToken;
}

export function getChargebacksBatch(id, date) {
    let getToken = new Promise<any>((resolve, reject) => {
        authProvider.getNexusToken()
            .then(x => {
                fetch(`/GozerApi/api/v2/chargebacks/batch/${id}/export`, {
                        method: 'GET',
                        headers: {
                            Authorization: 'Bearer ' + x,
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(r => r.blob())
                    .then((response) => {
                        download(response, `Chargebacks_Batch_${date}`)
                        resolve(null)
                    })
                    .catch(err => reject(err))
            })

        })
    return getToken;
}

export function getPaymentListings(body: any, date: string, setDownloading: any, offsetInMinutes: number) {
    setDownloading(true)
    let getToken = new Promise<any>((resolve, reject) => {
        authProvider.getNexusToken()
            .then(x => {
                const adjustedBody = convertModelDatesToUTCFromOperator(body, offsetInMinutes);
                fetch(`/api/v2/reports/payment-listing/export?offsetInMinutes=${Math.round(offsetInMinutes)}`, {
                        method: 'POST',
                        headers: {
                            Authorization: 'Bearer ' + x,
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(adjustedBody)
                    })
                    .then(r => r.blob())
                    .then((response) => {
                        download(response, `Payment_Listing_${date}`)
                        resolve(null)
                        setDownloading(false)
                    })
                    .catch(err => {
                        reject(err)
                        setDownloading(false)
                    })
            })

        })
    return getToken;
}

export function getRecurringListings(body, date, setDownloading, offsetInMinutes: number) {
    setDownloading(true)
    let getToken = new Promise<any>((resolve, reject) => {
        authProvider.getNexusToken()
            .then(x => {
                const adjustedBody = convertModelDatesToUTCFromOperator(body, offsetInMinutes);
                fetch("/api/v2/reports/recurring-signup/export", {
                        method: 'POST',
                        headers: {
                            Authorization: 'Bearer ' + x,
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(adjustedBody)
                    })
                    .then(r => r.blob())
                    .then((response) => {
                        download(response, `Recurring_Signups_Listing_${date}`)
                        resolve(null)
                        setDownloading(false)
                    })
                    .catch(err => {
                        reject(err)
                        setDownloading(false)
                    })
            })

        })
    return getToken;
}

function download(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    // the filename you want
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
}